import React, { useEffect, useState } from "react";

const Details = (props) => {
  const { currentIndex, totalSlides, titles, clients, years, roles } = props;

  

  // useEffect(() => {
  //   console.log('changing');
    
  // }, [currentIndex]);

  return (
    <section className="details__details-wrapper">
      <div className="details__details-item title">
        <div className="details__title">Project Title</div>
        <div className="details__entry bold">{titles[currentIndex]}</div>
      </div>
      <div className="details__details-item">
        <div className="details__title">Client</div>
        <div className="details__entry bold">{clients[currentIndex]}</div>
      </div>
      <div className="details__details-item">
        <div className="details__title">Year</div>
        <div className="details__entry bold">{years[currentIndex]}</div>
      </div>
      <div className="details__details-item roles">
        <div className="details__title">Role(s)</div>
        <div className="details__entry bold">{roles[currentIndex]}</div>
      </div>

      <div className="details__details-item counter">
        <div className="details__counter-wrapper bold">
          <strong>
            {currentIndex + 1} / {totalSlides}
          </strong>
        </div>
      </div>
    </section>
  );
};

export default Details;
